import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const DescriptionCell = ({getValue}) => {
  const description = getValue()
  return <Box fontWeight="500">{description}</Box>
}

DescriptionCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default DescriptionCell
